import { gql } from "@apollo/client";

export const UPDATE_VEHICLE_DESCRIPTION = gql`
  mutation addOrUpdateVehicle($input: AddOrUpdateVehicleInput!) {
    addOrUpdateVehicle(input: $input) {
      errors
      vehicle {
        id
        uuid
        description
      }
    }
  }
`;
export const UPDATE_VEHICLE_OWNER = gql`
  mutation addOrUpdateVehicle($input: AddOrUpdateVehicleInput!) {
    addOrUpdateVehicle(input: $input) {
      errors
      vehicleUuid
      ownerUuid
      vehicle {
        id
        uuid
        owner {
          id
          personalAttribute {
            id
            firstName
            lastName
          }
        }
      }
    }
  }
`;
export const UPDATE_VEHICLE_PLATE_TYPE = gql`
  mutation addOrUpdateVehicle($input: AddOrUpdateVehicleInput!) {
    addOrUpdateVehicle(input: $input) {
      errors
      vehicle {
        id
        uuid
        plateType {
          id
          oriId
          name
          position
        }
      }
    }
  }
`;
export const UPDATE_VEHICLE_VALUE = gql`
  mutation addOrUpdateVehicle($input: AddOrUpdateVehicleInput!) {
    addOrUpdateVehicle(input: $input) {
      errors
      vehicle {
        id
        uuid
        value
      }
    }
  }
`;

export const UPDATE_VEHICLE_COLOR = gql`
  mutation addOrUpdateVehicle($input: AddOrUpdateVehicleInput!) {
    addOrUpdateVehicle(input: $input) {
      errors
      vehicle {
        id
        uuid
        vehicleColor {
          id
          oriId
          name
          position
        }
      }
    }
  }
`;
export const UPDATE_VEHICLE_MAKE = gql`
  mutation addOrUpdateVehicle($input: AddOrUpdateVehicleInput!) {
    addOrUpdateVehicle(input: $input) {
      errors
      vehicle {
        id
        uuid
        vehicleMake {
          id
          oriId
          name
          position
        }
      }
    }
  }
`;
export const UPDATE_VEHICLE_MODEL = gql`
  mutation addOrUpdateVehicle($input: AddOrUpdateVehicleInput!) {
    addOrUpdateVehicle(input: $input) {
      errors
      vehicle {
        id
        uuid
        vehicleModel {
          id
          oriId
          name
          position
        }
      }
    }
  }
`;
export const UPDATE_VEHICLE_PLATE = gql`
  mutation addOrUpdateVehicle($input: AddOrUpdateVehicleInput!) {
    addOrUpdateVehicle(input: $input) {
      errors
      vehicle {
        id
        uuid
        vehiclePlate {
          id
          oriId
          name
          position
        }
      }
    }
  }
`;
export const UPDATE_VEHICLE_STATE = gql`
  mutation addOrUpdateVehicle($input: AddOrUpdateVehicleInput!) {
    addOrUpdateVehicle(input: $input) {
      errors
      vehicle {
        id
        uuid
        vehicleState {
          id
          oriId
          name
          position
        }
      }
    }
  }
`;
export const UPDATE_VEHICLE_VIN = gql`
  mutation addOrUpdateVehicle($input: AddOrUpdateVehicleInput!) {
    addOrUpdateVehicle(input: $input) {
      errors
      vehicle {
        id
        uuid
        vehicleVin {
          id
          oriId
          name
          position
        }
      }
    }
  }
`;

export const UPDATE_VEHICLE_YEAR = gql`
  mutation addOrUpdateVehicle($input: AddOrUpdateVehicleInput!) {
    addOrUpdateVehicle(input: $input) {
      errors
      vehicle {
        id
        uuid
        year
      }
    }
  }
`;

//will need to add validated to make and model
export const UPDATE_VEHICLE_ALL_FIELDS = gql`
  mutation addOrUpdateVehicle($input: AddOrUpdateVehicleInput!) {
    addOrUpdateVehicle(input: $input) {
      errors
      vehicle {
        id
        uuid
        description
        owner {
          id
        }
        plateType {
          id
          oriId
          name
          position
        }
        value
        vehicleColor {
          id
          oriId
          name
          position
        }
        vehicleMake {
          id
          oriId
          name
          position
        }
        vehicleModel {
          id
          oriId
          name
          position
        }
        vehiclePlate {
          id
          oriId
          name
          position
        }
        vehicleState {
          id
          oriId
          name
          position
        }
        vehicleVin {
          id
          oriId
          name
          position
        }
        year
        validVehicleAlerts {
          alertType {
            id
            name
            alertLevel
            oriId
            position
          }
          expireAt
          id
          notes
          officerId
          vehicle {
            id
          }
        }
      }
    }
  }
`;
